/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { celularMask } from "services/mask.js";
import { cnpjMask } from "services/mask.js";
import { CircularProgress } from "@material-ui/core";
import { AutoComplete } from "primereact/autocomplete";
import Select from "react-select";
import { getRequest } from "utils/request";
import { putRequest } from "utils/request";
import { useHistory } from "react-router-dom";
import { i18n } from "../../../translate/i18n";
import { states } from "utils/states";
import Swal from "sweetalert2";
import { useNotification } from "hooks/notification";
import { tzList } from "utils/timezoneList";

export default function TabCompany({ companyData, handleUpdate, updateSla }) {
  const [social, setSocial] = useState("");
  const [fantasia, setFantasia] = useState("");
  const [cnpj, setCnpj] = useState("");
  const [site, setSite] = useState("");
  const [timeZone, setTimeZone] = useState("");
  const [state, setState] = useState("");
  const [responsavel, setResponsavel] = useState("");
  const [respTel, setRespTel] = useState("");
  const [respEmail, setRespEmail] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [listcategory, setListCategory] = useState([]);
  const [listchannels, setListChannels] = useState([]);
  const [customerEmail, setCustomerEmail] = useState([]);
  const [skute, setSkute] = useState("");
  const [channels, setChannels] = useState([]);
  const [openIntegration, setOpenIntegration] = useState(false);
  const [openIntegrationInput, setOpenIntegrationInput] = useState("");
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const { addSelectedCompany, setUpdate, update, listOptionsCompanies } =
    useNotification();

  useEffect(() => {
    setLoading(true);
    if (companyData?.pending) {
      const data = states.filter(
        (e) => e?.value?.toLowerCase() === companyData?.state?.toLowerCase()
      );
      if (data[0]) {
        setState(data[0].description);
      } else {
        setState(companyData.state);
      }
    }

    getRequest(`/channels`).then(function (response) {
      const channels = response.data.filter((w) => w.id !== 3);
      if (!channels.length) {
        return;
      }
      let opt = `[`;
      channels.forEach(function (data, index) {
        opt += `{ "value": ${data.id}, "label": "${data.description}"},`;
      });
      opt = opt.substring(0, opt.length - 1);
      opt += `]`;
      setListChannels(JSON.parse(opt));
    });
    if (companyData.CompanyCategoryId) {
      getRequest(`/companiescategories/${companyData.CompanyCategoryId}`).then(
        function (response) {
          if (response.data) {
            setSelectedCategory(response.data);
          }
        }
      );
    }
    setLoading(false);

    setSocial(companyData.name);
    setFantasia(companyData.nickName);
    setCnpj(companyData.document);
    setSite(companyData.site);
    setResponsavel(companyData.responsibleName);
    setRespTel(companyData.responsibleCellPhone);
    setRespEmail(companyData.responsibleEmail);
    setSkute(companyData.skute);
    setTimeZone(companyData.timeZone);
    setCustomerEmail(companyData.customerEmail);
    if (companyData.openIntegration) {
      setOpenIntegration(true);
    }
    setOpenIntegrationInput(companyData.openIntegration);

    let companiesChannels = companyData.CompanyChannels;
    let companiesChannelsID = [];

    companiesChannels
      .filter((w) => w.Channel.id !== 3)
      .map((data) => {
        companiesChannelsID.push({
          value: data.Channel.id,
          label: data.Channel.description,
        });
      });
    setChannels(companiesChannelsID);
  }, []);

  const getCategories = async (e) => {
    await getRequest(
      `/companiescategories?text=${
        e.query
      }&offset=${0}&limit=${1000}&onlyActive=1`
    ).then(function (response) {
      if (response.data) {
        setListCategory(response.data);
      }
    });
  };

  const handleEdit = async () => {
    setLoading(true);

    const idchannels = [];
    channels.map((data) => {
      idchannels.push(data.value);
    });

    putRequest(`/companies/${companyData.id}`, {
      name: social,
      nickName: fantasia,
      CompanyCategoryId: Number(selectedCategory.id),
      pending: false,
      site: site,
      document: cnpj,
      responsibleName: responsavel,
      responsibleEmail: respEmail,
      responsibleCellPhone: respTel,
      Channels: idchannels,
      skute: Number(skute),
      timeZone,
      openIntegration: openIntegration ? openIntegrationInput : null,
    }).then(function (response) {
      if (response.success) {
        addSelectedCompany({
          value: response.data.id,
          id: response.data.id,
          trial: response.data.trial,
          trialLimit: response.data.trialValidate,
          label: response.data.nickName,
          logo: response.data.pathLogo,
          usersLimit: response.data.usersLimit,
          dueDay: response.data.dueDay,
          ticketToShow: response.data.ticketShowData,
        });
        if (idchannels.length < 1 && Number(skute) !== 1) {
          addSelectedCompany({
            value: listOptionsCompanies[0].value,
            id: listOptionsCompanies[0].value,
            label: listOptionsCompanies[0].nickName,
            logo: listOptionsCompanies[0].pathLogo,
            trial: listOptionsCompanies[0].trial,
            trialLimit: listOptionsCompanies[0].trialValidate,
            usersLimit: listOptionsCompanies[0].usersLimit,
            dueDay: listOptionsCompanies[0].dueDay,
            ticketToShow: listOptionsCompanies[0].ticketShowData,
          });
          setUpdate(update + 1);
        }
        handleUpdate(1);
        updateSla();
      }
      setLoading(false);
    });
  };

  const handleChangeCelular = (e) => {
    setRespTel(celularMask(e.target.value));
  };

  const handleChangeCNPJ = (e) => {
    setCnpj(cnpjMask(e.target.value));
  };

  const handleChangeChannels = (e) => {
    setChannels([]);

    if (e != null) {
      setChannels(e);
    }
  };

  const updateStatus = (status, id) => {
    const idchannels = [];
    channels.map((data) => {
      idchannels.push(data.value);
    });

    if (status === "approve") {
      putRequest(`/companies/approve/${id}`, {
        name: social,
        nickName: fantasia,
        CompanyCategoryId: Number(selectedCategory.id),
        pending: false,
        site: site,
        document: cnpj,
        responsibleName: responsavel,
        responsibleEmail: respEmail,
        responsibleCellPhone: respTel,
        Channels: idchannels,
        skute: Number(skute),
        timeZone,
        customerEmail,
        openIntegration: openIntegrationInput,
      }).then(() => {
        history.push("/dashboard/company");
        setUpdate(update + 1);
      });
    } else if (status === "reprove") {
      Swal.fire({
        title: i18n.t("reproveDesire"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: i18n.t("confirmReproveCompany"),
      }).then((result) => {
        if (result.isConfirmed) {
          putRequest(`/companies/reject/${id}`).then(() => {
            history.push("/dashboard/company");
          });
        }
      });
    }
  };

  return (
    <div className="list-container">
      <div className="title-helper-container" style={{ marginBottom: 10 }}>
        <h3>{companyData.nickName}</h3>
      </div>
      {!loading ? (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (companyData.pending) {
              updateStatus("approve", companyData.id);
            } else {
              handleEdit();
            }
          }}
        >
          <div className="form-row">
            <div className="form-group col-md-4">
              <label>{i18n.t("socialReason")} *</label>
              <input
                type="text"
                className="form-control"
                value={social}
                maxLength={100}
                required
                onChange={(value) => setSocial(value.target.value)}
              />
            </div>
            <div className="form-group col-md-4">
              <label> {i18n.t("fantasy")} *</label>
              <input
                type="text"
                className="form-control"
                required
                maxLength={100}
                value={fantasia}
                onChange={(value) => setFantasia(value.target.value)}
              />
            </div>
            <div className="form-group col-md-4">
              <label>{i18n.t("registry")} *</label>
              <input
                type="text"
                className="form-control"
                data-toggle="input-mask"
                data-mask-format="00.000.000/0000-00"
                data-reverse="true"
                maxLength="18"
                minLength="18"
                required
                value={cnpj}
                onChange={handleChangeCNPJ}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group col-md-3">
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label>{i18n.t("category")} *</label>
                <AutoComplete
                  value={selectedCategory}
                  suggestions={listcategory}
                  completeMethod={getCategories}
                  field="description"
                  dropdown
                  onChange={(e) => setSelectedCategory(e.value)}
                />
              </div>
            </div>
            <div className="form-group col-md-3">
              <label>{i18n.t("site")}</label>
              <input
                type="text"
                className="form-control"
                maxLength={255}
                value={site}
                onChange={(value) => setSite(value.target.value)}
              />
            </div>
            <div className="form-group col-md-2">
              <label> {i18n.t("timeZone")} *</label>
              <select
                className="form-control select2"
                data-toggle="select2"
                value={timeZone}
                name="timeZone"
                required
                onChange={(e) => setTimeZone(e.target.value)}
              >
                <option value="">{i18n.t("select")}</option>
                {tzList.map((data, index) => (
                  <option key={index} value={data.value}>
                    {data.label}
                  </option>
                ))}
              </select>
            </div>
            {companyData.pending && (
              <>
                <div className="form-group col-md-3">
                  <label>{i18n.t("description") + " Skute"} *</label>
                  <input
                    type="text"
                    className="form-control"
                    required
                    defaultValue={companyData.customerSkuteDescription}
                    disabled
                  />
                </div>
                <div className="form-group col-md-3">
                  <label>{i18n.t("state")}*</label>
                  <input
                    type="text"
                    className="form-control"
                    required
                    maxLength={2}
                    defaultValue={state}
                    disabled
                  />
                </div>
                <div className="form-group col-md-3">
                  <label>{i18n.t("city")} *</label>
                  <input
                    type="text"
                    className="form-control"
                    required
                    maxLength={30}
                    defaultValue={companyData.city}
                    disabled
                  />
                </div>
              </>
            )}
          </div>
          <h4 style={{ marginTop: 10 }} className="header-title">
            {i18n.t("contact")}
          </h4>

          <div className="form-row">
            <div className="form-group col-md-3">
              <label> {i18n.t("responsible")} *</label>
              <input
                type="text"
                className="form-control"
                required
                maxLength={100}
                value={responsavel}
                onChange={(value) => setResponsavel(value.target.value)}
              />
            </div>

            <div className="form-group col-md-3">
              <label>{i18n.t("phone")} *</label>
              <input
                type="text"
                className="form-control"
                data-toggle="input-mask"
                data-mask-format="(00) 00000-0000"
                maxLength="15"
                minLength="14"
                required
                value={respTel}
                onChange={handleChangeCelular}
              />
            </div>
            <div className="form-group col-md-4">
              <label>{i18n.t("email")} *</label>
              <input
                type="text"
                className="form-control"
                maxLength={100}
                required
                value={respEmail}
                onChange={(value) => setRespEmail(value.target.value)}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group col-md-4">
              <label> Skute *</label>
              <select
                className="form-control select2"
                data-toggle="select2"
                value={skute}
                required
                onChange={(value) => setSkute(value.target.value)}
              >
                <option value="">Selecione</option>
                <option value="1">Parceiro</option>
                <option value="2">Não Parceiro</option>
                <option value="3">Não faz parte</option>
              </select>
            </div>
            <div className="form-group col-md-4 mb-0">
              <label>{i18n.t("channel")}</label>
              <Select
                options={listchannels}
                placeholder={i18n.t("selectChannel")}
                isMulti={true}
                noOptionsMessage={() => i18n.t("emptyChannels")}
                getStyles="select2 form-control select2-multiple"
                value={channels}
                onChange={handleChangeChannels}
              />
            </div>
            <div className="form-row">
              <div className="form-group col-md-2 checkbox-openIntegration">
                <input
                  checked={openIntegration}
                  onClick={() => setOpenIntegration(!openIntegration)}
                  type="checkbox"
                />
                <label style={{ marginLeft: 10 }}>
                  {i18n.t("openIntegration")}
                </label>
              </div>
              {openIntegration && (
                <div className="form-group col-md-2">
                  <label>{i18n.t("informSystem")} *</label>
                  <input
                    type="text"
                    className="form-control"
                    maxLength={100}
                    name="openIntegration"
                    required
                    value={openIntegrationInput}
                    onChange={(e) => setOpenIntegrationInput(e.target.value)}
                  />
                </div>
              )}
            </div>
          </div>
          <div
            className="button-list mt-3 pull-right"
            style={{ position: "absolute", bottom: 0, right: 0 }}
          >
            {!companyData.pending ? (
              <div>
                <button type="submit" className="btn btn-outline-success">
                  <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                  {i18n.t("save")}
                </button>
              </div>
            ) : (
              <>
                <button
                  type="button"
                  className="btn btn-outline-danger"
                  onClick={(e) => {
                    e.preventDefault();
                    updateStatus("reprove", companyData.id);
                  }}
                >
                  <i className="mdi mdi-close"></i> {i18n.t("reprove")}
                </button>
                <button type="submit" className="btn btn-outline-success">
                  <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                  {i18n.t("approve")}
                </button>
              </>
            )}
          </div>
        </form>
      ) : (
        <div className="area-loading">
          <CircularProgress />
        </div>
      )}
    </div>
  );
}
